import {overEvery, keyBy, transform, sortBy, get, includes, camelCase, groupBy, createSelector} from 'helpers';
import {projects} from './projects';
import {categories} from './categories';
import {goalsList, inProgress, weeklyObjectives} from './goals';
import {createRestrictedSelector} from 'store/permissions';
import {sorting} from 'store/sorting';
import {filter, flatten, createdDateNegative} from 'store/common';

export const options = createSelector(
  [ sorting, state => state.settings.goals ],
  ( sorting, options ) => ({
    chartPeriod: 7,
    hasCustomOrder: Boolean(sorting),
    sort: 'target_date',
    status: 'In Progress',
    ...options,
  }),
);

export const weeklyObjectivesOptions = createSelector(
  [ state => state.settings.weeklyObjectives ],
  ( options ) => ({
    status: 'In Progress',
    ...options,
  }),
);

export const list = createSelector(
  [ goalsList, options, sorting, categories, projects, filter, createRestrictedSelector(inProgress, 'goals') ],
  ( goalsList, options, sorting, categories, projects, filter, isRestricted ) => {
    const filtered = goalsList.filter(overEvery(
      goal => includes(options.status, goal.status),
      goal => !goal.isWeeklyObjective,
      filter
    ));
    let { completed, onHold, inProgress } = groupBy(filtered, goal => {
      return isRestricted(goal) ? 'restricted' : camelCase(goal.status);
    });

    switch (options.sort) {
      case 'target_date':
        inProgress = sortBy(inProgress, goal => goal.target_date || 0, createdDateNegative);
        break;

      case 'starting_date':
        inProgress = sortBy(inProgress, goal => goal.starting_date || 0, createdDateNegative);
        break;

      case 'customOrder':
        inProgress = sortBy(inProgress, goal => get(sorting, goal.id, -1), createdDateNegative);
        break;

      case 'category':
        const projectsById = keyBy(projects, 'id');
        const ordered = transform(categories, (groups, category) => groups[category] = []);
        const { other, ...groups } = groupBy(sortBy(inProgress, createdDateNegative), goal => {
          if (projectsById[goal.typeId]) {
            return projectsById[goal.typeId].name;
          }
          return goal.category == 'other' ? 'other' : categories[goal.category];
        });
        return flatten({ ...ordered, ...groups, other, onHold, completed });
    }

    return flatten({ '': inProgress, onHold, completed });
  }
);

export const weeklyObjectivesList = createSelector(
  [ weeklyObjectives, weeklyObjectivesOptions, sorting, filter, createRestrictedSelector(inProgress, 'weeklyObjectives') ],
  ( weeklyObjectives, weeklyObjectivesOptions, sorting, filter, isRestricted ) => {

    const filtered = weeklyObjectives.filter(overEvery(
      goal => includes(weeklyObjectivesOptions.status, goal.status),
      filter
    ));

    let { completed, inProgress } = groupBy(filtered, goal => {
      return isRestricted(goal) ? 'restricted' : camelCase(goal.status);
    });

    inProgress = sortBy(inProgress, goal => goal.target_date || 0, createdDateNegative);

    return flatten({ '': inProgress, completed });
  }
);
